import { useQuery } from '@tanstack/react-query'

import { GetUserViewModel } from '@/types/pam-api'

import { LayoutReactQueryKeys } from '@/components/header/types'

import fetchRequest from '@/app/_utils/fetch-request'

const useUser = (refetchOnMount = false) => {
    const {
        data: user,
        refetch,
        isLoading,
        isFetching,
        isError,
    } = useQuery<GetUserViewModel>({
        queryKey: [LayoutReactQueryKeys.UserInfo],
        queryFn: () =>
            fetchRequest({
                method: 'GET',
                serviceName: 'pam',
                endpoint: `/users/_current`,
            }),
        retryOnMount: false,
        refetchOnMount,
    })

    return { isLoggedIn: !!user, isLoading, user, refetch, isFetching, isError }
}

export default useUser
